export const Agreement = [
  {
    title: '一、我们收集的信息',
    content: [
      '我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息。其中个人信息是指以电子或者其它方式记录的能够单独或者与其它信息结合识别自然人个人身份的各种信息，包括但不限于自然人的姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码等。', 
      '1.1 您在使用我们服务时主动提供的信息',
      '1.1.1 您在注册帐户时填写的信息。例如，您在注册帐户时所填写的昵称、手机号码等。',
      '1.1.2 您在使用服务时上传的信息。例如，您在使用软件服务时上传的头像、分享的照片等。',
      '1.1.3 您通过我们的客服或参加我们举办的活动时所提交的信息。例如，您参与我们线上活动时填写的调查问卷中可能包含您的姓名、电话、家庭地址等。我们的部分服务可能需要您提供特定的个人敏感信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其它功能。若您主动提供您的个人敏感信息，即表示您同意我们按本声明所述目的和方式来处理您的个人敏感信息（个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。例如，个人敏感信息包括身份证件号码、个人生物识别信息、银行账号、通信内容、健康生理信息等）。',
      '1.2 我们在您使用服务时获取的信息',
      '1.2.1 日志信息。当您使用我们的服务时，我们可能会自动收集相关信息并存储为服务日志信息。',
      '(1) 设备信息。例如，设备型号、操作系统版本、唯一设备标识符、电池、信号强度等信息。',
      '(2) 软件信息。例如，软件的版本号、浏览器类型。为确保操作环境的安全或提供服务所需，我们会收集有关您使用的移动应用和其它软件的信息。',
      '(3) IP地址。每台上网的设备都会指定一个编号，称为互联网协议IP地址。这些编号通常都是根据地理区域指定的。IP地址通常可用于识别设备连接至互联网时所在的位置。',
      '(4) 服务日志信息。例如，您在使用我们服务时搜索、查看的信息、服务故障信息、引荐网址等信息。',
      '(5) 通讯日志信息。例如，您在使用我们服务时曾经通讯的账户、通讯时间和时长。',
      '1.2.2 位置信息。当您使用与位置有关的服务时，我们可能会记录您设备所在的位置信息，以便为您提供相关服务。',
      '(1) 在您使用服务时，我们可能会通过IP地址、GPS、WiFi或基站等途径获取您的地理位置信息；',
      '(2) 您或其它用户在使用服务时提供的信息中可能包含您所在地理位置信息，例如您提供的帐号信息中可能包含的您所在地区信息，您或其它人共享的照片包含的地理标记信息；',
      '1.2.3 其它相关信息。为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。为确保您使用我们服务时能与您认识的人进行联系，如您选择开启导入通讯录功能，我们可能对您联系人的姓名和电话号码进行加密，并仅收集加密后的信息。为方便您及时同步日程信息到您的设备，如您选择开启读取日历的权限，我们会获取您的日历信息。',
      '1.3 其它用户分享的信息中含有您的信息。例如，其它用户发布的照片或分享的视频中可能包含您的信息。',
      '1.4 从第三方合作伙伴获取的信息。我们可能会获得您在使用第三方合作伙伴服务时所产生或分享的信息。例如，您登录第三方合作伙伴服务时，我们会获得您登录第三方合作伙伴服务的名称、登录时间。',
    ],
  },
  {
    title: '二、我们如何使用收集的信息',
    content: [
      '我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。',
      '2.1 向您提供服务。',
      '2.2 满足您的个性化需求。例如，语言设定、位置设定、个性化的帮助服务。',
      '2.3 产品开发和服务优化。例如，当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。',
      '2.4 安全保障。例如，我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。例如，您下载或安装的安全软件会对恶意程序或病毒进行检测，或为您识别诈骗信息。',
      '2.5 向您推荐您可能感兴趣的广告、资讯等。',
      '2.6 评估、改善我们的广告投放和其它促销及推广活动的效果。',
      '2.7 管理软件。例如，进行软件认证、软件升级等。',
      '2.8 邀请您参与有关我们服务的调查。为了让您有更好的体验、改善我们的服务或经您同意的其它用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其它服务。例如，将您在使用我们某项服务时的信息，用于另一项服务中向您展示个性化的内容或广告、用于用户研究分析与统计等服务。',
      '为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，您使用应用程序的频率、故障信息、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与您在应用程序中提供的个人身份信息相结合。',
      '',
      '',
      '',
    ],
  },
  {
    title:'三、我们如何使用Cookie及相关技术',
    content:[
      '为使您获得更轻松的访问体验，使用产品或服务过程中我们可能会通过采用各种技术收集和存储您访问的相关数据，在您访问或再次访问时我们能识别您的身份，并通过分析数据为您提供更好更多的服务。包括使用小型数据文件识别您的身份，这么做是为了解您的使用习惯，帮您省去重复输入账户信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie、Flash Cookie，或您的浏览器或关联应用程序提供的其它本地存储（统称“Cookie”）。',
      '请您理解，我们的某些服务只能通过使用Cookie才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝Cookie，但拒绝Cookie在某些情况下您可能无法使用依赖于Cookie的部分功能。',
    ],
  },
  {
    title:'四、您分享的信息',
    content:[
      '您可以通过我们的服务与您的好友、家人及其它用户分享您的相关信息。请注意，这其中可能包含您的个人身份信息、个人财产信息等敏感信息。请您谨慎考虑披露您的相关个人敏感信息。',
      '您可通过我们服务中的隐私设置来控制您分享信息的范围，也可通过服务中的设置或我们提供的指引删除您公开分享的信息。但请您注意，这些信息仍可能由其它用户或不受我们控制的非关联第三方独立地保存。',
    ],
  },
  {
    title:'五、您如何管理自己的信息',
    content:[
      '5.1 您可以在使用我们服务的过程中，访问、修改和删除您提供的注册信息和其它个人信息，也可按照通知指引与我们联系。您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。例如，若您在使用地理位置相关服务时，希望停止分享您的地理位置信息，您可通过手机定位关闭功能、软硬件服务商及通讯服务提供商的关闭方式停止分享，建议您仔细阅读相关指引。',
      '5.2 我们将按照本声明所述，仅为实现我们产品或服务的功能，收集、使用您的信息。如您发现我们违反法律、行政法规的规定或者双方的约定收集、使用您的个人信息，您可以要求我们删除。如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。请通过本声明列明的联系方式与我们联系。',
      '5.3 在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障帐号的安全。',
      '5.4 请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，我们会在合理的期限内答复您的请求。',
    ],
  },
  {
    title:'六、我们分享的信息',
    content:[
      '我们遵照法律法规的规定，对信息的分享进行严格的限制，例如：',
      '6.1 经您事先同意，我们可能与第三方分享您的个人信息。',
      '6.2 仅为实现外部处理的目的，我们可能会与第三方合作伙伴（第三方服务供应商、承包商、代理、广告合作伙伴、应用开发者等，例如，代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置服务的地图服务供应商）（他们可能并非位于您所在的法域）分享您的个人信息，让他们按照我们的说明、隐私声明以及其它相关的保密和安全措施来为我们处理上述信息，并用于以下用途：',
      '6.2.1 向您提供我们的服务。',
      '6.2.2 实现“我们如何使用收集的信息”部分所述目的。',
      '6.2.3 履行我们在《服务协议》或本声明中的义务和行使我们的权利。',
      '6.2.4 理解、维护和改善我们的服务。如我们与上述第三方分享您的信息，我们将会采用加密、匿名化处理等手段保障您的信息安全。',
      '6.3 随着我们业务的持续发展，当发生合并、收购、资产转让等交易导致向第三方分享您的个人信息时，我们将通过推送通知、公告等形式告知您相关情形，按照法律法规及不低于本声明所要求的标准继续保护或要求新的管理者继续保护您的个人信息。',
      '6.4 我们会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的城市热力图或行业洞察报告。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解用户如何使用我们服务或让公众了解我们服务的总体使用趋势。',
      '6.5 我们可能基于以下目的披露您的个人信息：',
      '6.5.1 遵守适用的法律法规等有关规定。',
      '6.5.2 遵守法院判决、裁定或其它法律程序的规定。',
      '6.5.3 遵守相关政府机关或其它法定授权组织的要求。',
      '6.5.4 我们有理由确信需要遵守法律法规等有关规定。',
      '6.5.5 为执行相关服务协议或本声明、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其它用户或雇员的人身财产安全或其它合法权益合理且必要的用途。',
    ],
  },
  {
    title:'七、我们可能向您发送的信息',
    content:[
      '7.1 信息推送。您在使用我们的服务时，我们可能向您发送电子邮件、短信、资讯或推送通知。',
      '7.2 与服务有关的公告。我们可能在必要时（例如，因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于广告的公告。',
    ],
  },
  {
    title:'八、存储信息的地点和期限',
    content:[
      '8.1 存储信息的地点',
      '我们遵守法律法规的规定，将境内收集的用户个人信息存储于境内。',
      '8.2 存储信息的期限',
      '一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：',
      '8.2.1 为遵守适用的法律法规等有关规定。',
      '8.2.2 为遵守法院判决、裁定或其它法律程序的规定。',
      '8.2.3 为遵守相关政府机关或法定授权组织的要求。',
      '8.2.4 我们有理由确信需要遵守法律法规等有关规定。',
      '8.2.5 为执行相关服务协议或本声明、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其它用户或雇员的人身财产安全或其它合法权益所合理必需的用途。',
      '当我们的产品或服务发生停止运营的情形时，我们将采取例如，推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。',
    ],
  },
  {
    title:'九、信息安全',
    content:[
      '我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露。',
      '9.1 我们严格遵守法律法规保护用户的通信秘密。',
      '9.2 我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们使用加密技术、匿名化处理等手段来保护您的个人信息。',
      '9.3 我们建立专门的管理制度、流程和组织确保信息安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审查。',
      '9.4 若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。',
    ],
  },
  {
    title:'十、广告',
    content:[
      '我们可能使用您的相关信息，在相关网站、应用及其它渠道向您提供与您更加相关的广告。为了保证良好的用户体验，尽可能地减少与您无关的广告对您造成的侵扰，我们会尽可能向您展示您可能更感兴趣、更实用的广告。在向您展示广告的过程中，我们将努力确保数据的安全性。',
    ],
  },
  {
    title:'十一、未成年人保护',
    content:[
      '我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用智鼎云的服务前，应事先取得您的家长或法定监护人的同意。',
    ],
  },
  {
    title:'十二、适用范围',
    content:[
      '我们的所有服务均适用本声明。但某些服务有其特定的隐私指引/声明，该特定隐私指引/声明更具体地说明我们在该服务中如何处理您的信息。如本声明与特定服务的隐私指引/声明有不一致之处，请以该特定隐私指引/声明为准。',
      '请您注意，本声明不适用由其它公司或个人提供的服务。例如，您通过使用智鼎云提供服务的帐号登录其它公司或个人提供的服务。',
      '您使用该等第三方服务须受其隐私声明（而非本声明）约束，您需要仔细阅读其声明内容。',
    ],
  },
  {
    title:'十三、联系我们',
    content:[
      '如果您对我们的隐私保护声明或数据处理有任何疑问、意见或建议，可以通过客服热线4000989222与我们联系，或邮寄至如下地址：',
      '地址：武汉东湖新技术开发区光谷创业街66-6号海达创新广场13楼',
    ],
  },
  {
    title:'十四、变更',
    content:[
      '我们可能适时修订本声明内容。如该等变更会导致您在本声明项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件等方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的声明约束。',
    ],
  }
]